import { render } from "./MyAlbumComponent.vue?vue&type=template&id=640014cc&ts=true"
import script from "./MyAlbumComponent.vue?vue&type=script&lang=ts"
export * from "./MyAlbumComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__